var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGboba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boba Goerli"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7573 19.9383C12.3329 19.9383 11.9745 19.6352 11.9031 19.2161L9.4872 5.01194C9.44813 4.78289 9.50067 4.55383 9.63541 4.3652C9.77015 4.17656 9.96957 4.05125 10.1973 4.01218C10.6689 3.93268 11.1175 4.25067 11.1984 4.72225L13.6143 18.9264C13.6533 19.1555 13.6008 19.3845 13.466 19.5732C13.3313 19.7618 13.1319 19.8871 12.9042 19.9262C12.857 19.9343 12.8072 19.9383 12.7573 19.9383Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.7573 19.9383C12.3329 19.9383 11.9745 19.6352 11.9031 19.2161L9.4872 5.01194C9.44813 4.78289 9.50067 4.55383 9.63541 4.3652C9.77015 4.17656 9.96957 4.05125 10.1973 4.01218C10.6689 3.93268 11.1175 4.25067 11.1984 4.72225L13.6143 18.9264C13.6533 19.1555 13.6008 19.3845 13.466 19.5732C13.3313 19.7618 13.1319 19.8871 12.9042 19.9262C12.857 19.9343 12.8072 19.9383 12.7573 19.9383Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.8057 13.3867C15.4246 13.3867 14.1405 13.8004 13.0667 14.5104L13.359 16.2297C14.282 15.4253 15.4879 14.9362 16.8057 14.9362C19.7039 14.9362 22.0618 17.2941 22.0618 20.1924C22.0618 23.0906 19.7039 25.4485 16.8057 25.4485C13.9074 25.4485 11.5495 23.0906 11.5495 20.1924C11.5495 19.8057 11.5926 19.4298 11.6721 19.0673L11.2059 16.3308C10.446 17.4289 10 18.7601 10 20.1937C10 23.9462 13.0532 26.9994 16.8057 26.9994C20.5581 26.9994 23.6113 23.9462 23.6113 20.1937C23.6113 16.4412 20.5595 13.3867 16.8057 13.3867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.4348 24.1646C16.9468 24.1646 17.3618 23.7495 17.3618 23.2376C17.3618 22.7256 16.9468 22.3105 16.4348 22.3105C15.9228 22.3105 15.5078 22.7256 15.5078 23.2376C15.5078 23.7495 15.9228 24.1646 16.4348 24.1646Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.3313 23.0864C19.8433 23.0864 20.2583 22.6714 20.2583 22.1594C20.2583 21.6475 19.8433 21.2324 19.3313 21.2324C18.8193 21.2324 18.4043 21.6475 18.4043 22.1594C18.4043 22.6714 18.8193 23.0864 19.3313 23.0864Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.0559 21.0981C17.5679 21.0981 17.9829 20.6831 17.9829 20.1711C17.9829 19.6592 17.5679 19.2441 17.0559 19.2441C16.5439 19.2441 16.1289 19.6592 16.1289 20.1711C16.1289 20.6831 16.5439 21.0981 17.0559 21.0981Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.177 22.0454C14.689 22.0454 15.104 21.6304 15.104 21.1184C15.104 20.6064 14.689 20.1914 14.177 20.1914C13.665 20.1914 13.25 20.6064 13.25 21.1184C13.25 21.6304 13.665 22.0454 14.177 22.0454Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.9231 20.1489C20.4351 20.1489 20.8501 19.7339 20.8501 19.2219C20.8501 18.71 20.4351 18.2949 19.9231 18.2949C19.4111 18.2949 18.9961 18.71 18.9961 19.2219C18.9961 19.7339 19.4111 20.1489 19.9231 20.1489Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.6731 18.0317C18.1851 18.0317 18.6001 17.6167 18.6001 17.1047C18.6001 16.5928 18.1851 16.1777 17.6731 16.1777C17.1611 16.1777 16.7461 16.5928 16.7461 17.1047C16.7461 17.6167 17.1611 18.0317 17.6731 18.0317Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.7688 19.1099C15.2808 19.1099 15.6958 18.6948 15.6958 18.1829C15.6958 17.6709 15.2808 17.2559 14.7688 17.2559C14.2568 17.2559 13.8418 17.6709 13.8418 18.1829C13.8418 18.6948 14.2568 19.1099 14.7688 19.1099Z",
    fill: "white"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGboba);
export default __webpack_public_path__ + "static/media/gboba.8c853b7c90d78b19ce285e051049a3fe.svg";
export { ForwardRef as ReactComponent };